import { QueryClient } from '@tanstack/react-query'

/**
 * Clears all session-related data including query cache and analytics.
 * Can be called from both client and server contexts.
 *
 * @param queryClient - The QueryClient instance to clear
 * @param options - Optional configuration
 * @param options.resetAnalytics - Whether to reset Mixpanel analytics (client-side only)
 */
export const clearSessionData = async (queryClient: QueryClient) => {
  // Reset analytics first if requested and on client side
  if (typeof window !== 'undefined') {
    const { mixpanelClient } = await import('@/lib/analytics/mixpanelClient')
    mixpanelClient.reset()
  }

  // Clear session query specifically first
  await queryClient.invalidateQueries({ queryKey: ['session'] })

  // Clear all queries
  await queryClient.clear()
}
